"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../../axios-client/axios-client.service");
var delivery_note_const_1 = require("./delivery-note.const");
/**
 * DeliveryNoteService
 * @class
 */
var DeliveryNoteService = /** @class */ (function () {
    function DeliveryNoteService() {
    }
    /**
     * Creates a new delivery note when valid `data` (delivery note) object is provided
     * @param data {DeliveryNote}
     * @returns Promise<DeliveryNoteSummary>
     */
    DeliveryNoteService.prototype.postDeliveryNote = function (data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = delivery_note_const_1.DELIVERY_NOTE_ENDPOINT.postDeliveryNote.replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    return DeliveryNoteService;
}());
/**
 * DeliveryNoteService Class Instance
 * @namespace
 */
exports.deliveryNote = new DeliveryNoteService();
